import React from 'react';
import type { TDocumentGenerationFormProps } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/types.ts';

export const StateAidReceivedDocumentGenerationForm: React.FC<TDocumentGenerationFormProps> = () =>
  null;
